module.exports = __webpack_public_path__ + "static/media/trash.ceb7a1f0.svg";